import React, { Component } from 'react';
import SearchInput, { createFilter } from 'react-search-input';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

const KEYS_TO_FILTERS = [ 'node.title' ];

class LocationSearchForm extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      searchTerm: ''
    };
    this.searchUpdated = this.searchUpdated.bind(this);
  }

  searchUpdated (term) {
    this.setState({searchTerm: term})
  };

  render() {
    const filteredLocations = this.props.locations.nodes.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
    return (
      <div className="LocationSearchForm">
        <SearchInput className="search-input" onChange={this.searchUpdated} placeholder="Search locations"/>
        <ul>
        {filteredLocations.map(location => {
          return (
            <li key={location.node.nid}>
              <Link to={'/location?location=' + location.node.nid}>{location.node.title}</Link>
            </li>
          )
        })}
        </ul>
      </div>
    )
  }
}

function mapStateToProps( state ) {
  return {
    locations: state.data.locations,
  };
}

export default connect( mapStateToProps )( LocationSearchForm );